import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import _ from 'underscore';

import helpers from './../helpers';
import config from './../config';

function PaginationButtons(props) {
	let pageButtons = [];
	let location = useLocation();

	let maxButtonCount = 7;

	let currentPage = parseInt(location.search != '' ? helpers.parseSearchParams(location.search).sida || 1 : 1);

	let startPage = currentPage;

	let pageSize = props.pageSize || 100;

	if (startPage > Math.floor(maxButtonCount/2) && props.resultCount/pageSize > maxButtonCount) {
		startPage = startPage-(Math.floor(maxButtonCount/2));
	}
	else {
		startPage = 1;
	}

	let maxPageCount = Math.ceil((props.resultCount/pageSize))+1;

	maxPageCount = maxPageCount > startPage+maxButtonCount ? startPage+maxButtonCount : maxPageCount;
	maxPageCount = maxPageCount > props.resultCount/pageSize ? Math.ceil(props.resultCount/pageSize) : maxPageCount;

	const buildUrl = (page) => {
		return location.pathname+helpers.updateSearchParams(location.search, {sida: page});
	};

	const linkButtonClickHandler = () => window.scrollTo(0, 0);

	if (startPage > 1) {
		pageButtons.push(
			<Link onClick={linkButtonClickHandler} key="1" className={'btn !bg-sam_theme/70'} to={buildUrl(1)} aria-label={window.l('Page 1')}>
				<span aria-hidden="true">1</span>
			</Link>
		);

		if (startPage > 2) {
			pageButtons.push(
				<div key="..." className="btn !bg-sam_theme/70">
					<span aria-hidden="true">...</span>
				</div>
			);
		}
	}

	for (let i = startPage; i<maxPageCount; i++) {
		pageButtons.push(
			<Link onClick={i != currentPage ? linkButtonClickHandler : null} key={i} className={'btn'+(i == currentPage ? '' : ' !bg-sam_theme/70')} to={buildUrl(i)} aria-label={window.l('Page')+' '+i}>
				<span aria-hidden="true">{i}</span>
			</Link>
		);
	}

	if (Math.ceil(props.resultCount/pageSize) > maxPageCount) {
		pageButtons.push(
			<div key="...." className="btn !bg-sam_theme/70">
				<span aria-hidden="true">...</span>
			</div>
		);
	}

	pageButtons.push(
		<Link onClick={linkButtonClickHandler} key={Math.ceil((props.resultCount/pageSize))} className="btn !bg-sam_theme/70" to={buildUrl(Math.ceil(props.resultCount/pageSize))} aria-label={window.l('Page')}>
				<span aria-hidden="true">{Math.ceil((props.resultCount/pageSize))}</span>
		</Link>
	);

	return <div className="my-4 flex justify-center gap-1">
			{
				props.previousUrl &&
				<Link onClick={linkButtonClickHandler} className={'btn !bg-sam_theme/70'} to={buildUrl(currentPage-1)} aria-label={window.l('Previous page')}>
					<span aria-hidden="true"><span className="arrows">&laquo;</span> {window.l('Previous page')}</span>
					<span className="sr-only">{window.l('Previous page')}</span>
				</Link>
			}
			{
				pageButtons
			}
			{
				props.nextUrl &&
				<Link onClick={linkButtonClickHandler} className="btn !bg-sam_theme/70" to={buildUrl(currentPage+1)} aria-label={window.l('Next page')}>
					<span aria-hidden="true">{window.l('Next page')} <span className="arrows">&raquo;</span></span>
					<span className="sr-only">{window.l('Next page')}</span>
				</Link>
			}
	</div>;
}

export default PaginationButtons;
